import PT from 'prop-types';

export const ExamAttachments = ({ attachments }) => (
  <ul className="exam-attachments">
    {attachments.map((attachment, i) => (
      <li key={`attachment_${i}`}>
        <a href={attachment.url} target="_blank" rel="noopener noreferrer">
          Print {attachment.title}
        </a>
      </li>
    ))}
  </ul>
);

ExamAttachments.propTypes = {
  attachments: PT.arrayOf(
    PT.shape({
      url: PT.string,
      title: PT.string,
    })
  ),
};
